import { render, staticRenderFns } from "./joinDone.vue?vue&type=template&id=6659e208&scoped=true"
import script from "./joinDone.vue?vue&type=script&lang=js"
export * from "./joinDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6659e208",
  null
  
)

export default component.exports